import "./BlogEntry.css";
import carImage from "../../assets/images/car-image.png";
import { useNavigate } from "react-router-dom";

const BlogEntry = ({ id }) => {
  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate(`/blog/${id}`);
  };

  return (
    <div className="blog-entry-container">
      <img className="blog-entry-image" src={carImage} alt="car-image" />
      <div className="blog-entry-content">
        <div className="blog-entry-content-top">
          <div className="blog-entry-button">Sustentabilidad</div>
          <span>Julio 31, 2025</span>
        </div>
        <h3>¿Por qué la sustentabilidad importa hoy más que nunca?</h3>
        <p>
          En un mundo donde el cambio climático y la pérdida de biodiversidad
          son desafíos cada vez más urgentes, adoptar ...
        </p>
      </div>
      <a onClick={handleNavigate}>Ver más &gt;</a>
    </div>
  );
};

export default BlogEntry;
